import React, { useState, useEffect, useMemo, useRef, useContext  } from "react";
import {Form, Modal, Button } from "react-bootstrap";
import { Grid } from "@material-ui/core";


const ConfirmPopup = ({type, show, setShow, title, des, clickAction, handleClose}) => {  


     
 
  return (
    <>
   

    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fixed-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title-size" id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Grid item id="area">
            {des.map((item, index)=>{
                return(
                     <p key={index} className="m-0 p-0">{item}</p>
                )
         })}
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>No</Button>
        <Button onClick={clickAction}>Yes</Button>
      </Modal.Footer>
    </Modal>
  </>
  
  );
}

export default ConfirmPopup;
